<template>
  <div id="app">
    <Loader />
    <router-view @login-success="setupInactivityTimer"/>
  </div>
</template>

<script>
import Loader from "@/components/layout/Loader";
import Session from '@/utils/session';
import Swal from "sweetalert2";
export default {
  data() {
    return {
      sessionTimeout: 15,
    }
  },
  components: {Loader},
  computed : {
    loading(){
      return this.$store.getters.getLoadingState;
    },
    // isSessionTimeoutEnabled: {
    //   get() {
    //     const itemKey = 'isSessionTimeoutEnabled';
    //     // Check if the item exists in localStorage
    //     const storedValue = localStorage.getItem(itemKey);
    //     // Return the parsed boolean value if it exists, or default to true
    //     return storedValue !== null ? storedValue === 'true' : true;
    //   },
    //   set(value) {
    //     // Store the updated value in localStorage whenever it changes
    //     localStorage.setItem('isSessionTimeoutEnabled', value.toString());
    //   }
    // }
  },
  created() {
    const storedValue = localStorage.getItem('sessionValue');
    if (storedValue === null) {
      localStorage.setItem('sessionValue', this.sessionTimeout)
      localStorage.setItem('sessionTimeout', this.sessionTimeout);
    }
    this.checkSession(); // Check if the user is logged in when the app loads
    this.setupInactivityTimer(); // Set up the session timeout timer

    const enabled = this.getIsSessionTimeoutEnabled();
    this.setIsSessionTimeoutEnabled(enabled);
  },
  methods : {
    getIsSessionTimeoutEnabled() {
      const key = 'isSessionTimeoutEnabled';
      const storedValue = localStorage.getItem(key);
      return storedValue !== null ? storedValue === 'true' : true;
    },
    setIsSessionTimeoutEnabled(value) {
      localStorage.setItem('isSessionTimeoutEnabled', value.toString());
    },
    checkSession() {
      // Check if session_id exists in localStorage
      const sessionId = localStorage.getItem('session_id');
      // if (!sessionId) {
      //   this.$router.push({ name: "login" }); // If no session ID, redirect to login
      // }
      if (!sessionId && this.$route.path !== '/') {
        alert("YOU'VE BEEN KICKED OUT!!!!!");
        // this.$router.push({ name: "login" }); // Redirect to login page
      }
    },
    setupInactivityTimer() {
      const logout = () => {
        // Clear session data on logout
        localStorage.removeItem('session_id');
        // this.$router.push({ name: "login" }); // Redirect to login page
        if (this.$route.path !== '/') {
          // alert("YOU'VE BEEN KICKED OUT");
          localStorage.removeItem('isLoggedIn');
          this.$nextTick(() => {
            Swal.fire({
              title: "Session Timed Out",
              text: "Your session has expired. If you wish to extend or reduce the timeout, go to Settings.",
              icon: "warning",
              confirmButtonText: "OK"
            }).then(() => {
              this.$router.push({ name: "login" });
            });
          });
        }

      };

      if (localStorage.getItem('isSessionTimeoutEnabled') === 'true') {
        // Start the session timer with the timeout duration
        Session.startTimer(logout);

        // Reset the timer on any user interaction
        const events = ['mousemove', 'keydown', 'click', 'touchstart'];
        events.forEach(event =>
            window.addEventListener(event, () => Session.resetTimer(logout))
        );
      }

      // // Start the session timer
      // Session.startTimer(logout);

      // Reset the timer on any user interaction
      // const events = ['mousemove', 'keydown', 'click', 'touchstart'];
      // events.forEach(event =>
      //     window.addEventListener(event, () => Session.resetTimer(logout))
      // );
    }
  },
  beforeDestroy() {
    Session.stopTimer(); // Clean up the timer when the component is destroyed
  }
}
</script>
<style lang="scss">

</style>
